import HeroPrimary from "@/components/sections/hero-banners/HeroPrimary";
import ErrorPrimary from '@/components/sections/error/ErrorPrimary';

export default function ErrorMain({ errors, status }) {
  return (
    <main>
      <HeroPrimary noText/>
      <ErrorPrimary errors={errors} status={status}/>
    </main>
  );
};
